// extracted by mini-css-extract-plugin
module.exports = {"meal":"MealItem_meal__1YPH4","description":"MealItem_description__395VA","price":"MealItem_price__hf9Uo"};